import { render, staticRenderFns } from "./SensorDeMovimiento.vue?vue&type=template&id=1343a5fe&scoped=true"
import script from "./SensorDeMovimiento.vue?vue&type=script&lang=js"
export * from "./SensorDeMovimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1343a5fe",
  null
  
)

export default component.exports